import { render, staticRenderFns } from "./FakeDataManagement.vue?vue&type=template&id=3f96d508&scoped=true&"
import script from "./FakeDataManagement.vue?vue&type=script&lang=js&"
export * from "./FakeDataManagement.vue?vue&type=script&lang=js&"
import style0 from "./FakeDataManagement.vue?vue&type=style&index=0&id=3f96d508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96d508",
  null
  
)

export default component.exports